const angular = require("angular");
const moment = require("moment");

class BillingAddressDetailsCtrl {
    /* @ngInject */
    constructor(
        $uibModal,
        $state,
        $scope,
        AuthSvc,
        logger,
        $translate,
        $filter,
        $window,
        SessionSvc,
        BillingAddressSvc
    ) {
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.AuthSvc = AuthSvc;
        this.logger = logger;
        this.$translate = $translate;
        this.$filter = $filter;
        this.$window = $window;
        this.SessionSvc = SessionSvc;
        this.BillingAddressSvc = BillingAddressSvc;

        this.TIME_MASK = {h: 0, m: 0, s: 0, ms: 0};
        this.DATE_FORMAT_MASK = 'YYYY-MM-DD';
        this.todayDate = moment(this.TIME_MASK).format(this.DATE_FORMAT_MASK);

        this.LOG_START_PDP = 'La date de début de PDP de réception doit être supérieure ou égale à la date du jour'
        this.LOG_END_PDP = 'La date de fin de PDP de réception doit être supérieure ou égale à la date de début et à la date du jour'
    }

    $onInit() {
        this.forEdit = this.$state.params.forEdit;
        this.canEditAdressDetails = this.AuthSvc.isAuthorized('CONFIGURATOR');
        this.billingAddressDto = {
            address: this.forEdit ? (this.billingAddress.address || null) : null,
            description: this.forEdit ? (this.billingAddress.description || null) : null,
            creationDate: this.forEdit ? (this.billingAddress.creationDate.format(this.DATE_FORMAT_MASK) || null) : null,
            pdpRe: {
                startDate: this.forEdit && this.billingAddress.pdpRe ? this.billingAddress.pdpRe.startDate : null,
                endDate: this.forEdit && this.billingAddress.pdpRe ? this.billingAddress.pdpRe.endDate : null,
                migrationCode: this.forEdit && this.billingAddress.pdpRe ? this.billingAddress.pdpRe.migrationCode : null,
                complianceStatus: this.forEdit && this.billingAddress.pdpRe ? this.billingAddress.pdpRe.complianceStatus : null,

            },
        };

        if (this.forEdit) {
            this.billingAddressDto.id = this.$state.params.billingAddressId
            this._initialBillingAddress = angular.copy(this.billingAddress)
            this.isDatePdpReChanged = this.datePdpReChanged();
            this.pdpReIsActive = this.isPdpReActive();
            this.canEditStartDatePdpRe = this.isEditableStartDatePdpRe();
            this.isSentoPppf = this.isSentToPpf();
            this.statusPpfSend = this.statusPpfSend();

        }
    }
    // Envoi à la PPF
    statusPpfSend() {
        var status = {};
        if (this._initialBillingAddress.pdpRe && this._initialBillingAddress.pdpRe.complianceStatus) {
            switch (this._initialBillingAddress.pdpRe.complianceStatus) {
                case 'RECEIVING_ADDRESS_PERIOD_ENCLOSES':
                case 'RECEIVING_ADDRESS_PERIOD_EXPIRED':
                case 'RECEIVING_ADDRESS_REQUEST_NOT_FOUND':
                case 'RECEIVING_ADDRESS_ALREADY_EXISTS':
                    status = { color: 'red', text: 'principal.company.not_sent_to_compliance' };
                    break;
                case 'SUCCESS':
                    status = { color: 'orange', text: 'principal.company.in_progress_to_compliance' };
                    break;
            }
        }
        return status;
    }

    isSentToPpf() {
        return this._initialBillingAddress.id && (this._initialBillingAddress.pdpRe != null && this._initialBillingAddress.pdpRe.sentToPpf == true);
    }

    isPdpReActive() {
        let today = moment(this.TIME_MASK)
        if ((!this._initialBillingAddress.pdpRe || this._initialBillingAddress.pdpRe.startDate==null) || this._initialBillingAddress.pdpRe && today.isAfter(this._initialBillingAddress.pdpRe.startDate) && !today.isSame(this._initialBillingAddress.pdpRe.startDate) && this._initialBillingAddress.pdpRe.endDate && today.isAfter(this._initialBillingAddress.pdpRe.endDate) && !today.isSame(this._initialBillingAddress.pdpRe.endDate)) {
            return false;
        }
        return true;
    }


    datePdpReChanged() {
        this.canEditStartDatePdpRe = this.isEditableStartDatePdpRe()
        this.isDatePdpReChanged = this.isStartDatePdpReChanged() || this.isEndDatePdpReChanged();
        return this.isDatePdpReChanged;
    }

    isStartDatePdpReChanged() {
        let startDatePdpReChanged = false
        if (this._initialBillingAddress.pdpRe && this._initialBillingAddress.pdpRe.startDate!=null) {
            let currentStartDate = this.form && this.form.pdpStartDateRe && this.form.pdpStartDateRe.$viewValue ? this.formatDate(this.form.pdpStartDateRe.$viewValue) : moment(this.billingAddressDto.pdpRe.startDate)
            startDatePdpReChanged = !this._initialBillingAddress.pdpRe.startDate.isSame(currentStartDate);
        } else if (this.form && this.form.pdpStartDateRe && this.form.pdpStartDateRe.$viewValue) {
            startDatePdpReChanged = true
        }
        return startDatePdpReChanged;
    }

    isEndDatePdpReChanged() {
        let EndPdpReChanged = false
        if (this._initialBillingAddress.pdpRe && this._initialBillingAddress.pdpRe.endDate) {
            let currentEndDate = this.form && this.form.pdpEndDateRe && this.form.pdpEndDateRe.$viewValue ? this.formatDate(this.form.pdpEndDateRe.$viewValue) : moment(this.billingAddressDto.pdpRe.endDate)
            EndPdpReChanged = !this._initialBillingAddress.pdpRe.endDate.isSame(currentEndDate);
        } else if (this.form && this.form.pdpStartDateRe && this.form.pdpStartDateRe.$viewValue) {
            EndPdpReChanged = true
        }
        return EndPdpReChanged;
    }

    isEditableStartDatePdpRe() {
        let initialStartDate = this._initialBillingAddress.pdpRe && this._initialBillingAddress.pdpRe.startDate ? moment(this._initialBillingAddress.pdpRe.startDate) : null
        let initialEndDate = this._initialBillingAddress.pdpRe && this._initialBillingAddress.pdpRe.endDate ? moment(this._initialBillingAddress.pdpRe.endDate) : null
        if (this.pdpReIsActive) {
            if (!this._initialBillingAddress.pdpRe || !this._initialBillingAddress.pdpRe.startDate || !this.billingAddressDto.pdpRe || !this.billingAddressDto.pdpRe.startDate) {
                return true
            } else if (initialStartDate && initialStartDate.isAfter(this.todayDate) && !initialStartDate.isSame(this.todayDate)) {
                return true
            } else if (this.billingAddressDto.pdpRe && this.billingAddressDto.pdpRe.endDate && initialEndDate && initialEndDate.isBefore(this.todayDate) && !initialEndDate.isSame(this.todayDate)) {
                return true
            }
        }
        return false
    }

    /** transforme une chaine de carac en une date
     *
     * @param dateString
     */
    formatDate(dateString) {
        if (dateString instanceof Date) {
            return moment(dateString).format(this.DATE_FORMAT_MASK);
        } else if (dateString) {
            // Remplace les "-" par "/" pour éviter tout problème
            const dateArray = dateString.split('/');

            // Crée une date au format UTC pour éviter le décalage
            const formatedDate = new Date(Date.UTC(dateArray[2], dateArray[1] - 1, dateArray[0]));

            return moment.utc(formatedDate).format(this.DATE_FORMAT_MASK); // Utilise moment.utc pour éviter les fuseaux horaires
        }
    }


    activeSyPdpRe() {
        // verifie si la date de debut est modifiable
        this.canEditStartDatePdpRe = this.isEditableStartDatePdpRe()
        if (!this.pdpReIsActive) { // verifie l'evenement décocher la case
            if (this._initialBillingAddress.pdpRe) {
                if (this._initialBillingAddress.pdpRe.startDate.isAfter(this.todayDate) && !this._initialBillingAddress.pdpRe.startDate.isSame(this.todayDate)) { // Si une période est déjà enregistrée en base et que période future vider les champs
                    this.clearStartPpdRe()
                    this.clearEndPpdRe()
                } else if (this._initialBillingAddress.pdpRe.startDate.isBefore(this.todayDate) && this._initialBillingAddress.pdpRe.endDate && this._initialBillingAddress.pdpRe.endDate.isBefore(this.todayDate) && !this._initialBillingAddress.pdpRe.startDate.isSame(this.todayDate) && !this._initialBillingAddress.pdpRe.endDate.isSame(this.todayDate)) { // Si une période est déjà enregistrer en base et que période achevée afficher les valeurs sauvegardées en base
                    this.clearStartPpdRe()
                    this.clearEndPpdRe()
                    this.billingAddressDto.pdpRe.startDate = this._initialBillingAddress.pdpRe.startDate;
                    this.billingAddressDto.pdpRe.endDate = this._initialBillingAddress.pdpRe.endDate;
                } else if (this._initialBillingAddress.pdpRe.startDate.isBefore(this.todayDate) || this._initialBillingAddress.pdpRe.startDate.isSame(this.todayDate)) { // Si une période est déjà enregistrée en base et que période en cours mettre la date du jour au niveau de <Date de fin>
                    this.clearEndPpdRe()
                    this.billingAddressDto.pdpRe.endDate = this.todayDate
                }
            } else { // Si aucune période n'est enregistrée en base, vider les champs
                this.clearStartPpdRe()
                this.clearEndPpdRe()
            }
            this.datePdpReChanged()
        }
    }

    minStartReDate() {
        return this.isStartDatePdpReChanged() ? this.todayDate : (this._initialBillingAddress.pdpRe && this._initialBillingAddress.pdpRe.startDate!=null && this._initialBillingAddress.pdpRe.startDate.isBefore(this.todayDate) ? new Date(this._initialBillingAddress.pdpRe.startDate) : this.todayDate)
    }

    maxStartReDate() {
        return this.billingAddressDto.pdpRe && this.billingAddressDto.pdpRe.endDate ? new Date(this.billingAddressDto.pdpRe.endDate) : null;
    }

    minEndReDate() {
        if (this.isEndDatePdpReChanged() && this.billingAddressDto.pdpRe && this.billingAddressDto.pdpRe.startDate && moment(this.billingAddressDto.pdpRe.startDate).isAfter(this.todayDate)) {
            return new Date(this.billingAddressDto.pdpRe.startDate)
        } else if (!this.isEndDatePdpReChanged() && this._initialBillingAddress.pdpRe && this._initialBillingAddress.pdpRe.endDate && !this._initialBillingAddress.pdpRe.endDate.isAfter(this.todayDate)) {
            return new Date(this._initialBillingAddress.pdpRe.endDate)
        } else {
            return this.todayDate
        }
    }

    clearStartPpdRe() { // vide le champs de date de debut PDP en reception
        this.billingAddressDto.pdpRe.startDate = null;
        this.form.pdpStartDateRe.$setValidity('min', true)
        this.form.pdpStartDateRe.$setValidity('date', true)
        this.form.pdpStartDateRe.$setPristine()
    }

    clearEndPpdRe() { // vide le champs de date de fin PDP en reception
        this.billingAddressDto.pdpRe.endDate = null;
        this.form.pdpEndDateRe.$setValidity('min', true)
        this.form.pdpEndDateRe.$setValidity('date', true)
        this.form.pdpEndDateRe.$setPristine()
    }

    cancel() {
        this.$onInit();
    }

    create() {
        if (this.form.$valid) {
            this.BillingAddressSvc.saveBillingAddress(this.billingAddressDto, this.legalEntity.id).then(
                (data) => {
                    this._onSaveSuccess('success.create');
                    this.$state.go('app.principal.consult.edit-billing_address', { forEdit: true, billingAddressId :data.id ,legalEntityId: this.legalEntity.id});
                },
                error => {
                    this._onSaveError(error);
                }
            );
        }
    }
    update(){
        this.setPdpBeforSave()
        if(this.form.$valid){
            this.BillingAddressSvc.updateBillingAddress(this.billingAddressDto, this.legalEntity.id).then(
                () => {
                    this._onSaveSuccess('success.update');
                    this.$window.location.reload()
                },
                error => {
                    this._onSaveError(error);
                }
            );
        }else if (this.canShowStartDatePdPReToasterError()) {
            this.logger.error(this.LOG_START_PDP)
        } else if (this.canShowEndDatePdPReToasterError()) {
            this.logger.error(this.LOG_END_PDP)
        }

    }
    setPdpBeforSave() {
        this.setPdpRe()
    }
    setPdpRe(){
        if(this.billingAddressDto.pdpRe){
            const startDate = this.form.pdpStartDateRe.$viewValue
                ? this.formatDate(this.form.pdpStartDateRe.$viewValue)
                : null;
            const endDate = this.form.pdpEndDateRe.$viewValue
                ? this.formatDate(this.form.pdpEndDateRe.$viewValue)
                : null;
            if(startDate){
                this.billingAddressDto.pdpRe.startDate = startDate;
                this.billingAddressDto.pdpRe.endDate = endDate;

            }
        }
    }

    canShowStartDatePdPReToasterError() {
        return (this.datePdpReChanged() && this.billingAddressDto.pdpRe.startDate.isBefore(this.todayDate))
    }

    /**
     * Indique si on doit afficher le toaster d'erreur de la date de fin de reception PDP
     */
    canShowEndDatePdPReToasterError() {
        return (this.isEndDatePdpReChanged() || this.isStartDatePdpReChanged()) && this.billingAddressDto.pdpRe && this.billingAddressDto.pdpRe.endDate && this.billingAddressDto.pdpRe.endDate.isBefore(this.billingAddressDto.pdpRe.startDate) && !this.billingAddressDto.pdpRe.endDate.isSame(this.billingAddressDto.pdpRe.startDate);
    }
    _onSaveSuccess(message /*:string*/) {

        this.logger.success(message, null, null, {entityName: 'L\'adresse de facturation'});
    }

    back() {
        this.$state.go('app.principal.consult.detailscompanies', {
            legalEntityId: this.legalEntity.id
        });
    }

    _onSaveError(error) {
        if (error.status === 400 && error.data) {
            switch (error.data.code) {
                case 'BILLING_ADDRESS_ADDRESS_INVALID':
                    this.logger.error('error.functional.BILLING_ADDRESS_ADDRESS_INVALID');
                    break;
                case 'START_DATE_PDP_INVALID':
                    this.logger.error('error.functional.start_date_pdp_invalid');
                    break;
                default:
                    break;
            }
        }
    }
}

angular.module('app.principal').component('billingAddressDetails', {
    templateUrl: require('./billing-address-details.html'),
    controller: BillingAddressDetailsCtrl,
    bindings: {
        legalEntity: '<',
        forEdit: '<',
        billingAddressId: '<',
        billingAddress: '<',

    }
});
